import React from "react";

import { useTranslation } from "react-i18next";

import useFAST from "../../../contexts/FASTContext";
import WebSocketStatus from "../../webSocket/WebSocketStatus";

import type { JSX } from "react";

export default function EditModeBox(): JSX.Element {
  const { t } = useTranslation("editor-fast-channel");
  const { state } = useFAST();

  const { isOwned, lockingAccount } = state.scheduleEditInfo;

  const isExternalLock = Boolean(lockingAccount);

  return (
    <div className="flex gap-[0.78125rem]">
      {isExternalLock ? (
        <div className="border-destructive flex items-center gap-[0.78125rem] rounded-[0.46875rem] border-2 px-[0.9375rem] py-[0.625rem] font-medium">
          <div
            className="size-[1.875rem] shrink-0 rounded-full bg-cover bg-center"
            style={{
              backgroundImage: `url(${lockingAccount?.avatar})`,
            }}
          />
          {isOwned ? (
            <div>{t("youAreCurrentlyEditing")}</div>
          ) : (
            <div>
              {`${lockingAccount?.firstName} ${lockingAccount?.lastName} `}
              <span className="text-destructive">
                {t("isCurrentlyEditingThisSchedule")}
              </span>
            </div>
          )}
        </div>
      ) : null}
      <WebSocketStatus />
    </div>
  );
}
